import { Clipboard } from '@capacitor/clipboard';
export const copyToClipboard = (data: string): Promise<void> => {
  return Clipboard.write({ string: data });
};
